import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfirmRtoRequestComponent } from "./component/confirm-rto-request.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  declarations: [ConfirmRtoRequestComponent],
  imports: [
    // fuse
    FuseSharedModule,

    // material
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class ConfirmRtoRequestModule {}
